// Third Party
import React from 'react';

// Utils
import { formatLocalizedString, formatMessage } from '../../../utils/i18n';

// Components
import { CloseButton } from '../buttons';
import InstrumentComparisonTable from '../compliance-comparison/InstrumentComparisonTable';
import ShelfStatus from '../shelf-management/ShelfStatus';
import Fund from '@/types/fund';
import { HOLDING_TYPES } from '@/utils/portfolios';
import { FormattedMessageV2 } from '../i18n';
import { ALLOWED_HTML_TAGS } from '../i18n/FormattedMessageV2';
import { Typography } from '@capintel/component-lib/typography';

type Props = {
  complianceAlternatives: Fund[];
  clearComplianceAlternatives: () => void;
  selectComplianceAlternative: (fund: Fund) => void;
  onClose: () => void;
};

const EditPortfolioFundComparison = ({ complianceAlternatives, clearComplianceAlternatives, onClose, selectComplianceAlternative }: Props) => {
  if (complianceAlternatives.length > 0) {
    const selectedFund = complianceAlternatives[0];
    const selectedFundSymbols = selectedFund.symbols && selectedFund.symbols.join(', ');

    return (
      <div className="edit-portfolio-fund-comparison">
        <div className="edit-portfolio-screener-header">
          <div className="title">
            <Typography as={ALLOWED_HTML_TAGS.H2} color="primary" variant="header2Xs">
              <FormattedMessageV2 toLocalize="EditPortfolioModal.ComplianceComparison" />
            </Typography>
          </div>
          <CloseButton
            onClick={() => {
              clearComplianceAlternatives();
              onClose();
            }}
            customLabel={formatMessage('Common.Close')}
          />
        </div>
        <div className="fund-header">
          <div>
            <h6 className="fund-symbols">{selectedFundSymbols}</h6>
            <h4 className="fund-name">
              {formatLocalizedString(selectedFund.names?.full)}
              {selectedFund.flags && <ShelfStatus statuses={selectedFund.flags} />}
            </h4>
          </div>
        </div>
        <InstrumentComparisonTable<Fund>
          complianceAlternatives={complianceAlternatives}
          instrumentType={HOLDING_TYPES.FUND}
          clearComplianceAlternatives={clearComplianceAlternatives}
          onSelect={selectComplianceAlternative}
        />
      </div>
    );
  }

  return null;
};

export default EditPortfolioFundComparison;
